import { ContentCard } from "@msuite/ui/content-card";
import { DataGrid } from "@msuite/ui/data-grid";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Panels } from "@msuite/ui/panels";
import { useQuery } from "@msuite/ui/query";
import { StatusIndicator } from "@msuite/ui/status-indicator";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import { Can } from "@/components/citadel";
import Notes from "@/components/notes";
import { client } from "@/hono";
import type { ContactPanelBaseProps } from "../types";
import { ContactStatistics } from "./contact-statistics";

export function ContactGeneral({ contactId }: ContactPanelBaseProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { data: contact } = useQuery({
		queryKey: ["contact", contactId ?? ""],
		queryFn: async () => {
			if (!contactId) throw new Error("Contact ID is required");
			const response = await client.contacts[":contactId"].$get({
				param: { contactId },
			});
			const data = await responseHandler(response);
			return data.contact;
		},
	});

	/** Render */
	return (
		<Panels>
			<Panels.Panel flex={1}>
				<ContentCard
					title="General Information"
					icon={icon("Info")}
				>
					<DataGrid>
						<DataGrid.Row>
							<DataGrid.Label>{t("general.type")}</DataGrid.Label>
							<DataGrid.Value className="h-stack">
								<StatusIndicator color={contact?._type?.color} />
								{guardString(contact?._type?.name)}
							</DataGrid.Value>
						</DataGrid.Row>
					</DataGrid>
				</ContentCard>
				{/* The route behind this card gates on both pairs, so both have to hold. */}
				<Can
					action="read"
					subject="ContactProjects"
				>
					<Can
						action="read"
						subject="Invoice"
					>
						<ContactStatistics />
					</Can>
				</Can>
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<Notes
					notesTable="contactNotes"
					identifier={contactId}
				/>
			</Panels.Panel>
		</Panels>
	);
}
